import { KolumnaSpisuFiltrowanie } from './kolumnaSpisuFiltrowanie';

export class PobierzSpisaneSrodkiLokalizacjiFiltry {
  kolumnyFiltrowania: Array<KolumnaSpisuFiltrowanie> = new Array();
  idLokalizacji: string;
  czyOswiadczenia?: boolean;
}
